(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("stylesheetInject", [], factory);
	else if(typeof exports === 'object')
		exports["stylesheetInject"] = factory();
	else
		root["stylesheetInject"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/